/**
 * TapToStartOverlay Component
 * Captures the initial user gesture required to initialize Web Audio API
 */

interface TapToStartOverlayProps {
  onTap: () => void;
}

export function TapToStartOverlay({ onTap }: TapToStartOverlayProps) {
  return (
    <div
      onClick={onTap}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(10, 10, 15, 0.95)',
        backdropFilter: 'blur(8px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '24px',
        zIndex: 1000,
        cursor: 'pointer',
        userSelect: 'none'
      }}
    >
      <div style={{
        fontFamily: 'Syne, sans-serif',
        fontSize: '48px',
        fontWeight: 800,
        letterSpacing: '-2px',
        color: 'var(--accent-b)',
        textAlign: 'center',
        lineHeight: 1.2
      }}>
        SIMON<br/>REVOLUTION
      </div>
      
      <div style={{
        padding: '16px 32px',
        background: 'var(--accent-b)',
        color: 'var(--bg)',
        borderRadius: '12px',
        fontSize: '18px',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '1px',
        animation: 'pulse 2s ease-in-out infinite'
      }}>
        Tap to Start
      </div>

      <div style={{
        fontSize: '14px',
        color: 'var(--muted)',
        maxWidth: '300px',
        textAlign: 'center',
        lineHeight: 1.6
      }}>
        Match the sequence of lights and sounds.<br/>
        The buttons move between rounds!
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.8; transform: scale(1.05); }
        }
      `}</style>
    </div>
  );
}
